window.bootstrap = require("bootstrap");
window.uniqid = require('uniqid');

import './_docready.js';
import './_forms.js';
import './_toggle_password.js';
import './_toasts.js';
import './_tags.js'
import './_lists.js';
import './_upload.js';
import './_frm_projet.js';
import './_selectmulti.js';
import './_main_menu.js';
import './_qrscanner.js';
import './_charts.js';